import { useContext } from 'react'
import { AppContext } from '../../contexts/AppContext';
import theme from "../theme"
import Body from "./Body"
import Header from "./Header"
import { Backdrop } from './Backdrop'
import { CircularProgress } from './CircularProgress'

export const CREToolTab = (props) => {

    const { title, children } = props
    const { loading } = useContext(AppContext)

    return (
        <div style={{ backgroundColor: theme.palette.background.tab, display: "flex", flexDirection: 'column', minWidth: "100%", minHeight: "100%"}}>
            {title && <Header title={title} />}
            <Body>
                {children}
            </Body>
            <Backdrop open={loading} sx={{zIndex: 10000}}>
                <CircularProgress color='primary' />
            </Backdrop>
        </div>
    )
}